import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full h-full flex items-center justify-center"
}
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!

  return (_ctx.imageUrls === undefined)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_icon, { class: "is-loading" }, {
          default: _withCtx(() => [
            _createVNode(_component_Loading)
          ]),
          _: 1
        })
      ]))
    : (_ctx.imageUrls.length > 0)
      ? (_openBlock(), _createBlock(_component_el_carousel, {
          key: 1,
          trigger: "click",
          height: _ctx.height,
          align: "center",
          autoplay: false
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageUrls, (imgUrl) => {
              return (_openBlock(), _createBlock(_component_el_carousel_item, { key: imgUrl }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: imgUrl,
                    class: "carousel-image"
                  }, null, 8, _hoisted_2)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["height"]))
      : _createCommentVNode("", true)
}